export default "__VITE_ASSET__cc0ff7fe__"